import ScopeConstants from "constants/ScopeConstants"
import { ScopeShape } from "@gman/gman-redux"
import PropTypes from "prop-types"

export const ClientScope = {
    key: ScopeConstants.CLIENT,
    selector: (state) => state.clients,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Client/Search/",
    singleEndpoint: "/api/Client/Get/",
    updateEndpoint: "/api/Client/Update/",
    deleteEndpoint: "/api/Client/Delete/",
    defaultRecord: {
        name: "",
        code: ""
    }
}

ClientScope.propTypes = PropTypes.shape(ScopeShape).isRequired